import { REMINDER_LEVELS } from './invoiceRemindersText';

const TONES = {
  gray: 'bg-gray-100 text-gray-800',
  blue: 'bg-blue-100 text-blue-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  red: 'bg-red-100 text-red-800',
};

const LEVEL_TONES = {
  before_due: 'blue',
  first: 'gray',
  second: 'yellow',
  third: 'red',
};

const levelBadge = (step) =>
  step && REMINDER_LEVELS.includes(step.level)
    ? { key: step.level, tone: LEVEL_TONES[step.level] }
    : null;

/**
 * The step a row shows (JBWEB-1283): the contentious invoice says so; else
 * the step due, else "Relances épuisées" once the 3rd went, else the next
 * step ("À venir"), else the last one sent ("Réglées"). "Relance n/3"
 * everywhere and "Rappel" before the due date (plan § 0, the cards over the
 * mockup's "1re relance").
 */
export const stepBadgeOf = (item) => {
  if (item.litigation) return { key: 'litigation', tone: 'red' };
  if (item.dueStep) return levelBadge(item.dueStep);
  if (item.exhausted) return { key: 'exhausted', tone: 'red' };
  if (item.nextStep) return levelBadge(item.nextStep);
  if (item.lastSent) return levelBadge(item.lastSent);
  return null;
};

/** What stands in the way of a reminder, for an invoice still reminded. */
export const flagBadgesOf = (item, tab) => {
  if (item.litigation || tab === 'settled') return [];
  return [
    item.noRecipient && { key: 'noRecipient', tone: 'red', hint: true },
    item.suspended && { key: 'suspended', tone: 'gray', hint: true },
    item.uncertain && { key: 'uncertain', tone: 'yellow', hint: true },
  ].filter(Boolean);
};

const Pill = ({ tone, label, hint }) => (
  <span
    title={hint}
    className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ${TONES[tone]}`}
  >
    {label}
  </span>
);

/** The badges of a row of the reminders: its step, then what blocks or worries. */
const ReminderBadges = ({ item, tab, text }) => {
  const step = stepBadgeOf(item);
  const flags = flagBadgesOf(item, tab);
  if (!step && flags.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-1">
      {step && <Pill tone={step.tone} label={text(`badges.${step.key}`)} />}
      {flags.map((flag) => (
        <Pill
          key={flag.key}
          tone={flag.tone}
          label={text(`badges.${flag.key}`)}
          hint={flag.hint ? text(`badgeHints.${flag.key}`) : undefined}
        />
      ))}
    </div>
  );
};

export default ReminderBadges;
